import React, { useState } from 'react';
import { Button, HStack, Text, VStack } from '@adc/parallax-component-library';
import i18n from '../../utilities/i18n';
import { Dialog } from 'tamagui';
import './Modal.scss';
import { UploadHistoryTable } from '../pages/sensorComponents/UploadHistoryTable';

type Props = {
  deviceId: string;
  deviceName: string;
  trigger: React.ReactNode;
};

export const UploadHistoryModal = ({
  deviceId,
  deviceName,
  trigger,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen}>
      {trigger ? (
        <Dialog.Trigger onPress={() => setIsOpen(true)} asChild>
          {trigger}
        </Dialog.Trigger>
      ) : null}
      <Dialog.Portal>
        <Dialog.Overlay key="overlay" />
        <Dialog.Content key="content" width="90%">
          <VStack gap="$2">
            <Dialog.Title>
              <Text type="$h3.strong">
                {i18n.t('Modal_UploadHistory.title', {
                  device: deviceName,
                })}
              </Text>
            </Dialog.Title>
          </VStack>

          <VStack flex={1} minHeight={0} overflow="scroll">
            <UploadHistoryTable deviceId={deviceId} showCard={false} />
          </VStack>

          <HStack justifyContent="flex-end" gap="$2" flexShrink={0}>
            <Button
              variant="secondary"
              onPress={() => setIsOpen(false)}
              label={i18n.t('Common.close')}
            />
          </HStack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};
